// extracted by mini-css-extract-plugin
export var alertCard = "layout-module--alertCard--d7ad5";
export var alertIcon = "layout-module--alertIcon--9cfc2";
export var alertSection = "layout-module--alertSection--5370f";
export var alertText = "layout-module--alertText--28fac";
export var blue = "layout-module--blue--c1335";
export var contentC = "layout-module--contentC--c17c5";
export var hasProductNavC = "layout-module--hasProductNavC--bae18";
export var light = "layout-module--light--7677c";
export var transparentBgC = "layout-module--transparentBgC--91896";